import { createContext, useContext, useState, ReactNode } from "react";

interface AgendamentoData {
  nome: string;
  dataNascimento: string;
  whatsapp: string;
  email: string;
}

interface HorarioData {
  date: string;
  time: string;
  type: "online" | "presencial";
}

interface BookingContextType {
  agendamento: AgendamentoData | null;
  horario: HorarioData | null;
  setAgendamento: (data: AgendamentoData | null) => void;
  setHorario: (data: HorarioData | null) => void;
  clearBooking: () => void;
}

const BookingContext = createContext<BookingContextType | undefined>(undefined);

export function BookingProvider({ children }: { children: ReactNode }) {
  const [agendamento, setAgendamento] = useState<AgendamentoData | null>(null);
  const [horario, setHorario] = useState<HorarioData | null>(null);

  const clearBooking = () => {
    setAgendamento(null);
    setHorario(null);
  };

  return (
    <BookingContext.Provider value={{ agendamento, horario, setAgendamento, setHorario, clearBooking }}>
      {children}
    </BookingContext.Provider>
  );
}

export function useBooking() {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error("useBooking must be used within a BookingProvider");
  }
  return context;
}
